import dayjs from 'dayjs'
import Personnummer from 'personnummer'

export const getYearsOld = (birthDate: string) => {
  return dayjs().diff(birthDate, 'year')
}

export const getYearsOldFromSSN = (ssn: string) => {
  return Personnummer.valid(ssn) ? Personnummer.parse(ssn).getAge() : 0
}

export const extractDOB = (ssn: string) => {
  if (!Personnummer.valid(ssn)) {
    return ''
  }
  const date = Personnummer.parse(ssn).getDate()
  return dayjs(date).format('YYYY-MM-DD')
}
